const email = {
	name: 'Email Address | Email Addresses',
	icon: '',
	fields: {
		email: 'Email Address',
		communication_type: 'Communication type',
		description: 'Description',
		typeNotFound: 'Type not found',
	},
}

export default email
